export default __webpack_public_path__ + "static/media/cursor.d3c37249.svg";